



















import Component from "vue-class-component";

import ViewList from "@/views/List.vue";
import { Getter } from "vuex-class";
import CatalogList from "@/components/zero-waste/list/CatalogList.vue";
import CatalogForm from "@/components/forms/zero-waste/CatalogForm.vue";
import _ from "lodash";

const components = {
    CatalogList,
    CatalogForm
};

@Component({ components })
export default class List extends ViewList {
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    protected filters: object = {};
    protected formVisible: boolean = false;
    protected catalogSelected: any = null;

    public showCatalog(catalog: any): void {
        this.formVisible = true;
        this.catalogSelected = catalog ? catalog : null;
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }

    public updateCatalog(catalog: any): void {
        this.catalogSelected = catalog;
        const catalogList = _.get(this.$refs, "catalogList", null);
        _.invoke(catalogList, "refreshList");
    }
    private close() {
        this.catalogSelected = null;
    }
}
